import {
  useTranslation,
  type TranslationKeys,
} from "@/hooks/useTranslation/useTranslation"
import { cn } from "@/lib/utils"
import { Link } from "react-router"
import { formatInt, localeForLanguage } from "../supplierDashboardStore"
import type { DashboardWidgetProps } from "../widgetRegistry"

const MC_BASE = "/material-compliance"

const ROWS: {
  labelKey: TranslationKeys
  value: (s: DashboardWidgetProps["stats"]) => number
  status: "escalated" | "undeliverable" | "complained"
  warn?: boolean
}[] = [
  {
    labelKey: "MC_SSD_HB_ESCALATED",
    value: (s) => s.handedBack.escalated,
    status: "escalated",
    warn: true,
  },
  {
    labelKey: "MC_SSD_HB_UNDELIVERABLE",
    value: (s) => s.handedBack.undeliverable,
    status: "undeliverable",
  },
  {
    labelKey: "MC_SSD_HB_COMPLAINED",
    value: (s) => s.handedBack.complained,
    status: "complained",
  },
]

export function HandedBackWidget({ stats }: DashboardWidgetProps) {
  const { translate, currentLanguage } = useTranslation()
  const locale = localeForLanguage(currentLanguage)
  return (
    <div>
      {ROWS.map((row) => {
        const warn = row.warn && row.value(stats) > 0
        return (
          <Link
            key={row.labelKey}
            to={`${MC_BASE}/supplier-studio/inquiry?status=${row.status}`}
            className={cn(
              "-mx-1 flex items-baseline justify-between gap-4 rounded-sm border-t border-white/5 px-1 py-3 text-sm text-grey5 transition-colors first:border-t-0 hover:bg-white/3 hover:text-white focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring",
              warn && "text-warning hover:text-warning",
            )}
          >
            <span>{translate(row.labelKey)}</span>
            <b
              className={cn(
                "font-semibold tabular-nums text-white",
                warn && "text-warning",
              )}
            >
              {formatInt(row.value(stats), locale)}
            </b>
          </Link>
        )
      })}
    </div>
  )
}
